import { inject, injectable, interfaces } from 'inversify';
import { IReviewRejectReasonsStore } from './reviewRejectReasons.store';
import { GetRejectionReasonRequest, IRejectionReasonService } from './services/rejectionReason.service';

export interface IReviewRejectionReasonBl {
  getReasons(projectId: string): Promise<void>;
  handleRejection(reason: string): void;
}

export namespace IReviewRejectionReasonBl {
  export const $: interfaces.ServiceIdentifier<IReviewRejectionReasonBl> = Symbol('REVIEW_REJECTION_REASON_BL');
}

const _listSize = 10;

@injectable()
export class ReviewRejectionReasonBl implements IReviewRejectionReasonBl {
  constructor(
    @inject(IReviewRejectReasonsStore.$) private readonly reviewStore: IReviewRejectReasonsStore,
    @inject(IRejectionReasonService.$) private readonly rejectionReasonService: IRejectionReasonService
  ) {}

  async getReasons(projectId: string): Promise<void> {
    const result = await this.rejectionReasonService.getRejectionReasons(new GetRejectionReasonRequest(projectId));
    if (result instanceof Error) {
      throw result;
    }
    this.reviewStore.setRejectionReasons(result);
  }

  handleRejection(reason: string): void {
    const trimmed = reason.trim();
    if (trimmed.length === 0) {
      return;
    }

    const rejectionReasons = this.reviewStore.rejectionReasons.slice();
    const index = rejectionReasons.findIndex((x) => x.reason.toLowerCase() === trimmed.toLowerCase());

    if (index > -1) {
      const rejectionReason = rejectionReasons[index];
      rejectionReasons.splice(index, 1);
      rejectionReasons.unshift(rejectionReason);
    } else {
      if (rejectionReasons.length >= _listSize) {
        rejectionReasons.pop();
      }
      rejectionReasons.unshift({ reason: trimmed, order: 0 });
    }
    const sorted = rejectionReasons.map((x, i) => ({ reason: x.reason, order: i }));
    this.reviewStore.setRejectionReasons(sorted);
  }
}
